import createSvgIcon from '../Utils/CreateSvgIcon';

export const Pound = createSvgIcon(
  <path d="M5.512 18.6H7.84v-5.232H5.632v-2.256H7.84V9.72c0-2.224.528-3.936 1.584-5.136 1.072-1.216 2.592-1.824 4.56-1.824 1.312 0 2.536.272 3.672.816l-.504 2.4c-1.072-.512-2.112-.768-3.12-.768-2.336 0-3.504 1.568-3.504 4.704v1.2h4.92v2.256h-4.92V18.6H17.8V21H5.512v-2.4Z" />,
  'Pound',
);
